import { render, staticRenderFns } from "./CreateAPIToken.vue?vue&type=template&id=65337e18"
import script from "./CreateAPIToken.vue?vue&type=script&lang=js"
export * from "./CreateAPIToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports